<template>
  <el-col :xs="xs" :sm="sm" :md="md" :lg="lg" :xl="xl" :class="_class">
    <slot></slot>
  </el-col>
</template>

<script>
export default {
  props: {
    xs: {
      default: 12
    },
    sm: {
      default: 12
    },
    md: {
      default: 8
    },
    lg: {
      default: 6
    },
    xl: {
      default: 6
    },
    type: {
      default: "nomal"
    }
  },
  data() {
    return {};
  },
  computed: {
    _class() {
      return [this.type === "last" ? "unex-search-grid_el-col-last" : ""];
    }
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {}
};
</script>

<style lang="less">
.unex-search-grid_el-col-last {
  float: right;
  display: flex;
  padding-top: 16px;
  justify-content: flex-end;
}
</style>
